import HomepageCOTMCarousel from './HomepageCOTMCarousel';
import ListpageCOTMCarousel from './ListpageCOTMCarousel';

export { HomepageCOTMCarousel, ListpageCOTMCarousel };
